import { render, staticRenderFns } from "./OurService.vue?vue&type=template&id=57919d72&scoped=true"
import script from "./OurService.vue?vue&type=script&lang=js"
export * from "./OurService.vue?vue&type=script&lang=js"
import style0 from "./OurService.vue?vue&type=style&index=0&id=57919d72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57919d72",
  null
  
)

export default component.exports